import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M81.2473 22.5033C82.6262 23.6524 82.8125 25.7017 81.6634 27.0806L39.9967 77.0806C39.4071 77.7882 38.5448 78.2123 37.6244 78.2476C36.704 78.2829 35.8118 77.9259 35.1698 77.2655L14.3364 55.8369C13.0852 54.55 13.1142 52.4924 14.4012 51.2412C15.6881 49.99 17.7457 50.019 18.9969 51.3059L37.3141 70.1464L76.67 22.9194C77.819 21.5405 79.8684 21.3542 81.2473 22.5033Z'

const IconTick: FC<IconProps> = props => <SvgIcon {...props} path={PATH} />

export default IconTick
